import Link from 'next/link';
import { useRouter } from 'next/router';

import { IMenuItem } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';

import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';
import { AdvertisingLabelWithTooltip } from '@r1-frontend/ui-react/organisms/AdvertisingLabelWithTooltip';

import * as ST from './styled';

export enum EMenuType {
    mainMenu = 'Main',
    rightMenu = 'Right',
}

interface IProps {
    item: IMenuItem,
    isOnlyPromo?: boolean,
    onClickHandler: (menuType: EMenuType, title: string) => void,
}

const DescriptionButtonImage = ({ item, isOnlyPromo = false, onClickHandler }: IProps): JSX.Element => {
    const { asPath } = useRouter();
    const { title, add_desc, image, image_webp, image_animated, link, button_text, button_link, labels = [], advertising } = item;

    return (
        <ST.PromoItemWrapper
            isPromoMemu={isOnlyPromo}
            isCurrent={asPath === link}
            onClick={() => onClickHandler(EMenuType.mainMenu, title)}
        >
            <ST.ImageBlock isPromoMemu={isOnlyPromo} data-test='subitem-img'>
                <Link href={link} prefetch={false} passHref>
                    <a>
                        {advertising && (
                            <NonStaticContainer
                                $united={{
                                    $bottom: 12,
                                    $right: 12,
                                }}
                            >
                                <AdvertisingLabelWithTooltip
                                    onClick={(e) => e.preventDefault()}
                                    companyName={advertising.companyName}
                                    erid={advertising.erid}
                                    tooltip={{
                                        zIndex: 999,
                                        closeOnTransition: true,
                                    }}
                                />
                            </NonStaticContainer>
                        )}
                        <WebpImage urlWebp={image_webp}>
                            <ST.ItemImage src={image} alt={title}/>
                        </WebpImage>
                        <ST.AnimationImg
                            src={image_animated}
                        />
                    </a>
                </Link>
            </ST.ImageBlock>
            <ST.ContentBlock isPromoMemu={isOnlyPromo}>
                <Link href={link} prefetch={false} passHref>
                    <ST.ContentLinkWrapper>
                        {labels.length
                            ? <ST.LabelsBlock>
                                {labels.map(label => (
                                    <ST.SLabel
                                        key={label.id}
                                        textColor={label.color_text}
                                        bgColor={label.color}
                                    >
                                        {label.title}
                                    </ST.SLabel>
                                ))}
                            </ST.LabelsBlock>
                            : <></>
                        }
                        <ST.ItemTitle title={title} isPromo/>
                        {add_desc && <ST.ItemDescription description={add_desc} isPromo/>}
                    </ST.ContentLinkWrapper>
                </Link>
                {button_link && <ST.ItemBtn btnText={button_text} btnLink={button_link} data-test='subitem-btn'/>}
            </ST.ContentBlock>
        </ST.PromoItemWrapper>
    );
};

export default DescriptionButtonImage;
